module.exports = __webpack_public_path__ + "static/media/7.16.374077e9.png";